import { axios, toCamelCase, toSnakeCase } from '@utils';

const BASE_URL = '/api/v1/legup/schedules';

async function createSchedule(params) {
  try {
    const { data } = await axios.post(BASE_URL, toSnakeCase(params));
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function updateSchedule(params, id) {
  try {
    const { data } = await axios.put(`${BASE_URL}/${id}`, toSnakeCase(params));
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function deleteSchedule(id) {
  try {
    const { data } = await axios.delete(`${BASE_URL}/${id}`);
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function fetchScheduleTypes() {
  try {
    const { data } = await axios.get('/api/v1/schedule_types');
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

export {
  createSchedule,
  updateSchedule,
  deleteSchedule,
  fetchScheduleTypes,
};
